var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacy-page"},[_vm._m(0),(_vm.content)?_c('div',{staticClass:"privacy-content",domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('div',{staticClass:"loading"},[_vm._v("加载中...")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacy-header"},[_c('h1',[_vm._v("隐私协议")])])
}]

export { render, staticRenderFns }